import React, { useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      console.log("SENDING:", { email });
      await api.post("/api/password-reset-request/", { email });
      setSent(true);
    } catch (e) {
      setError("If this email exists, you will receive a reset link shortly.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 420, margin: "40px auto", padding: 24, border: "1px solid #ddd", borderRadius: 8 }}>
      <h2>Forgot Your Password?</h2>
      {sent ? (
        <div style={{ color: "green", margin: "24px 0" }}>
          Check your email for a password reset link. The link expires in 20 minutes.
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <label htmlFor="reset-email">Email</label>
          <input
            id="reset-email"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
            style={{ display: "block", width: "100%", margin: "12px 0", padding: 8, fontSize: 16 }}
            disabled={loading}
          />
          <button
            type="submit"
            disabled={loading || !email}
            style={{ width: "100%", padding: 12, background: "#007bff", color: "#fff", border: "none", borderRadius: 4, fontWeight: 600, fontSize: 16 }}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>
      )}
      {error && <div style={{ color: "red", marginTop: 12 }}>{error}</div>}
      <button
        style={{ marginTop: 24, background: "none", border: "none", color: "#007bff", cursor: "pointer", fontSize: 15 }}
        onClick={() => navigate("/login")}
      >
        Back to login
      </button>
    </div>
  );
};

export default ForgotPasswordPage;
